import { render, staticRenderFns } from "./FormEntregar.vue?vue&type=template&id=8df126ca&"
import script from "./FormEntregar.vue?vue&type=script&lang=js&"
export * from "./FormEntregar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports